import script from "./TabelRiwayatUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelRiwayatUpload.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__